const locale = {
    updateProfile:'Update Profile',
    changePassword:'Change Password',
    myProfile:'My Profile',
    currentPassword:'Current Password :',
    newPassword:'New Password :',
    confirmPassword:'Confirm Password :',
    name:'Name :',
    email:'Email :',
    position:'Position :',
    affiliation:'Affiliation :',
    memberType:'Member Type :',
    groupType:'Group Type :',
    logged_session: 'Sessions'
};

export default locale;